module.exports = __webpack_public_path__ + "img/car450.a86895bf.png";